<template>
  <!-- 查看厂区路线指引-查看当前排队情况-来访车辆安全告知书  列表 -->
  <div class="noticecont">
    <div
      class="read"
      v-for="(item, index) in bg"
      :key="index"
      @click="viewDetail(item.route, item.query)"
    >
      <img :src="item.img" alt="图片加载失败" width="100%" />
      <div class="read-blk">
        <span class="read-blk-span">{{ item.title }}</span
        ><br />
        <van-button
          :color="`linear-gradient(to right, ${item.color1}, ${item.color2})`"
          class="read-blk-btn"
        >
          {{ btnText }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["bg", "btnText"],
  data() {
    return {};
  },
  created() {},
  methods: {
    // 查看详情
    viewDetail(route, query) {
      this.$emit("viewDetail", route, query);
    }
  }
};
</script>
<style lang="less">
.noticecont {
  .read {
    padding: 14px 0px 0px;
    &-blk1 {
      // background-image: url("../assets/img/line_up_bg.png");
      background-repeat: no-repeat;
      background-size: noticecontain;
    }
    &-blk {
      position: absolute;
      font-size: 17px;
      color: #1f3d36;
      letter-spacing: 0.8px;
      line-height: 17px;
      text-align: left;
      margin-top: -67px;
      padding-left: 27px;
      &-span {
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-wrap: break-word;
        display: inline-block;
        opacity: 0.7;
      }
      &-btn {
        font-size: 12px;
        padding: 11px 13px;
        height: 20px;
        border-radius: 11px;
        margin-top: 7px;
        line-height: 20px;
      }
    }
  }
}
</style>
